import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import NavItem from "./NavItem";
import Sidebar from "./Sidebar";
import primaryLogo from "../../../assets/images/Extra/PrimaryIcon.webp";
import Breadcrumbs from "./Breadcrumb";

const Header = () => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // ✅ NEW (does not affect existing logic)
  const [activeSection, setActiveSection] = useState("home");

  const isHome = location.pathname === "/";
  const learnMode =
    location.pathname === "/products" ||
    location.pathname === "/ourProcess";

  const linkBase =
    "relative text-sm font-medium transition-colors duration-300 px-2 py-1 " +
    'after:content-[""] after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-full ' +
    "after:origin-left after:scale-x-0 after:bg-accent after:transition-transform after:duration-300";

  const activeClass = "text-primary after:scale-x-100";
  const inactiveClass =
    "text-text-secondary hover:text-primary hover:after:scale-x-100";

  return (
    <>
      <header className="sticky top-0 z-50 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4">
          <div className="h-16 flex items-center justify-between">
            {/* LEFT: Logo */}
            <div className="flex items-center gap-3">
              <a href="#" aria-label="Sacrum 3D Home">
  <img
    src={primaryLogo}
    alt="Sacrum 3D logo"
    className="h-10 w-auto object-contain"
  />
</a>

            </div>

            {/* DESKTOP NAV */}
            <nav className="hidden lg:flex gap-8 items-center">
              <NavItem
                label="Home"
                sectionId="home"
                forceActive={isHome }
                // onActive={setActiveSection} // ✅ ADD
              />

              {isHome && !learnMode && (
                <>
                  <NavItem label="About" sectionId="about" onActive={setActiveSection} />
                  <NavItem label="Innovation" sectionId="innovation" onActive={setActiveSection} />
                  <NavItem label="Blog" sectionId="blog" onActive={setActiveSection} />
                  <NavItem label="Testimony" sectionId="testimony" onActive={setActiveSection} />
                  <NavItem label="Contact" sectionId="contact" onActive={setActiveSection} />
                </>
              )}

              {isHome && learnMode && (
                <>
                  <NavLink
                    to="/products"
                    className={({ isActive }) =>
                      `${linkBase} ${isActive ? activeClass : inactiveClass}`
                    }
                  >
                     Product Renders
                  </NavLink>

                  <NavLink
                    to="/ImageGallery"
                    className={({ isActive }) =>
                      `${linkBase} ${isActive ? activeClass : inactiveClass}`
                    }
                  >
                    Image Gallery
                  </NavLink>

                  <NavLink
                    to="/ourProcess"
                    className={({ isActive }) =>
                      `${linkBase} ${isActive ? activeClass : inactiveClass}`
                    }
                  >
                    Our Process
                  </NavLink>
                </>
              )}

              {!isHome && (
                <>
                  <NavLink
                    to="/products"
                    className={({ isActive }) =>
                      `${linkBase} ${isActive ? activeClass : inactiveClass}`
                    }
                  >
                     Product Renders
                  </NavLink>

                   <NavLink
                    to="/ImageGallery"
                    className={({ isActive }) =>
                      `${linkBase} ${isActive ? activeClass : inactiveClass}`
                    }
                  >
                    Image Gallery
                  </NavLink>

                  <NavLink
                    to="/ourProcess"
                    className={({ isActive }) =>
                      `${linkBase} ${isActive ? activeClass : inactiveClass}`
                    }
                  >
                    Our Process
                  </NavLink>
                </>
              )}
            </nav>

            {/* RIGHT SIDE ACTIONS */}
{/* <div className="hidden lg:flex items-center"> */}
<div className="flex items-center">
  <button
    onClick={() => window.open("http://portal.sacrum3d.com/", "_blank")}
    className="
      px-6 py-2 rounded-xl
      bg-primary text-white text-sm font-medium
      hover:scale-[1.03] active:scale-[0.98]
      transition-transform
    "
  >
    Login
  </button>
  
</div>

            {/* MOBILE */}
            <button className="lg:hidden" onClick={() => setSidebarOpen(true)}>
              ☰
            </button>
          </div>

          {/* MOBILE ONLY: Breadcrumb */}
          <div className="lg:hidden pb-2">
            <Breadcrumbs activeSection={activeSection} />
          </div>

          
        </div>
      </header>

      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isHome={isHome}
        learnMode={learnMode}
      />
    </>
  );
};

export default Header;